import { render, staticRenderFns } from "./ActionPeriod.vue?vue&type=template&id=b37fdb1e&scoped=true"
import script from "./ActionPeriod.vue?vue&type=script&lang=js"
export * from "./ActionPeriod.vue?vue&type=script&lang=js"
import style0 from "./ActionPeriod.vue?vue&type=style&index=0&id=b37fdb1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37fdb1e",
  null
  
)

export default component.exports